import { Injectable } from '@angular/core';

/**
 * @deprecated Il vecchio metodo `trace` faceva una POST verso un endpoint
 * configurato sul menu (`TraceStartEndpoint` / `TraceEndEndpoint`). Quel
 * meccanismo e' stato rimosso: ora ogni menu puo' avere `traceStartScript` /
 * `traceEndScript` (codice JS) eseguiti lato client da
 * `SiaRouteChangeTraceComponent` tramite `execScript`. La classe e' lasciata
 * vuota per non rompere import esterni; verra' rimossa in seguito.
 */
@Injectable({
  providedIn: 'root',
})
export class SiaRouterApi {}
